export const datadogRum = {
  init: () => undefined,
  setUser: () => undefined,
  addError: () => undefined,
}
